import type { StudentsQuery } from '@innovamat/glow-api-client';
import { useStudentsQuery } from '@innovamat/glow-api-client';
import type { QueryClient } from '@tanstack/react-query';

import {
  updateClassroomsCount,
  updateOrganizationCount,
  updateSingleClassroomCount,
} from './cache-utils';

type DeleteStudent = {
  queryClient: QueryClient;
  studentId: string;
  organizationId: string;
  classroomId: string;
};

function deleteStudentInCache({
  queryClient,
  studentId,
  organizationId,
  classroomId,
}: DeleteStudent): void {
  const key = useStudentsQuery.getKey({
    classroomId,
    organizationId,
  });

  const studentsQuery = queryClient.getQueryData<StudentsQuery>(key);

  if (studentsQuery) {
    const newData = studentsQuery.students?.filter(
      (student) => student?.id !== studentId
    );

    queryClient.setQueryData(key, {
      students: newData,
    });
  }

  updateOrganizationCount({
    queryClient,
    organizationId,
    studentsChange: -1,
    deletedStudentsChange: 1,
  });

  updateSingleClassroomCount({
    queryClient,
    classroomId,
    organizationId,
    countChange: -1,
  });

  updateClassroomsCount({
    queryClient,
    organizationId,
    updates: [{ classroomId, countChange: -1 }],
  });
}

export { deleteStudentInCache };
